import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "children"];
import React from 'react';
import styled from 'styled-components';
import { dropIn } from 'styles/animations';
import { typeScale, spacing } from 'styles/globals';
export var ALERT_STYLES = ['fail', 'success', 'info'];
export var AlertTypes = /*#__PURE__*/function (AlertTypes) {
  AlertTypes["SUCCESS"] = "success";
  AlertTypes["FAIL"] = "fail";
  AlertTypes["INFO"] = "info";
  return AlertTypes;
}({});
var AlertWrapperTypes = /*#__PURE__*/function (AlertWrapperTypes) {
  AlertWrapperTypes["SUCCESS"] = "alert-success";
  AlertWrapperTypes["FAIL"] = "alert-fail";
  AlertWrapperTypes["INFO"] = "alert-info";
  return AlertWrapperTypes;
}(AlertWrapperTypes || {});
var AlertWrapper = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'type';
  }
}).withConfig({
  displayName: "Alert__AlertWrapper",
  componentId: "sc-116t21k-0"
})(["position:relative;padding:0 ", ";font-size:", ";border-left:", " solid ", ";animation:", " 0.45s ease-out both;"], spacing.s, typeScale.s, spacing.xxs, function (p) {
  return p.theme.globals.colorBlocks[p.type];
}, dropIn);
export var alertTypeMap = {
  success: AlertWrapperTypes.SUCCESS,
  info: AlertWrapperTypes.INFO,
  fail: AlertWrapperTypes.FAIL
};
var Alert = function Alert(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? AlertTypes.FAIL : _ref$type,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var alertType = alertTypeMap[type] || type;
  return /*#__PURE__*/React.createElement(AlertWrapper, _extends({}, otherProps, {
    type: alertType,
    "data-qa-alert-type": alertType
  }), children);
};
export default Alert;